// 任务详情面板
import { List, Tag, Progress, Space, Empty } from 'antd';
import { CheckCircleFilled, ClockCircleOutlined } from '@ant-design/icons';
import { useStore } from '../store/account';
import {
  DAILY_SIGNIN_BONUS,
  TASK1_BUY_BONUS,
  TASK1_DAILY_CAP,
  TASK2_HEIST_RATIO,
  TASK2_HEIST_INTERVAL,
  TASK3_PROFIT_THRESHOLD,
  TASK3_PROFIT_BONUS,
} from '../../shared/constants';
import type { TaskStatus } from '../../shared/types';
export default function TasksPanel() {
  const { account } = useStore();
  if (!account) return <Empty description="加载中" />;
  const tasks: TaskStatus[] = [
    {
      id: 'signin',
      name: '每日签到',
      description: '每天打开应用签到，奖励现金',
      completed: account.signedToday,
      progress: account.signedToday ? 1 : 0,
      target: 1,
      reward: `+${DAILY_SIGNIN_BONUS.toLocaleString()}`,
    },
    {
      id: 'task1_buy',
      name: '买入任务',
      description: `买入任意一只股票即可获得奖励（每日上限 ${TASK1_DAILY_CAP} 次）`,
      completed: account.task1CountToday >= TASK1_DAILY_CAP,
      progress: account.task1CountToday,
      target: TASK1_DAILY_CAP,
      reward: `+${TASK1_BUY_BONUS.toLocaleString()}/只`,
    },
    {
      id: 'task2_heist',
      name: '被偷补贴',
      description: `每被黑哥们光顾 ${TASK2_HEIST_INTERVAL} 次，按"上一次"被偷金额的 ${(TASK2_HEIST_RATIO * 100).toFixed(0)}% 发放补贴`,
      completed: false,
      progress: account.heistCount % TASK2_HEIST_INTERVAL,
      target: TASK2_HEIST_INTERVAL,
      reward: `+${account.lastHeistAmount > 0 ? Math.round(account.lastHeistAmount * TASK2_HEIST_RATIO).toLocaleString() : '??'}`,
    },
    {
      id: 'task3_profit',
      name: '浮盈奖励',
      description: `每只股票浮盈达到 ${(TASK3_PROFIT_THRESHOLD * 100).toFixed(0)}% 即可获得奖励（卖出后重置）`,
      completed: Object.values(account.task3Claimed).some((v) => v),
      progress: Object.values(account.task3Claimed).filter((v) => v).length,
      target: account.positions.length || 1,
      reward: `+${TASK3_PROFIT_BONUS.toLocaleString()}/只`,
    },
  ];
  return (
    <div style={{ padding: 16 }}>
      {' '}
      <List
        dataSource={tasks}
        renderItem={(t) => {
          const percent = t.target > 0 ? Math.round((t.progress / t.target) * 100) : 0;
          return (
            <List.Item style={{ padding: 16, borderBlockEnd: '1px solid #30363d' }}>
              {' '}
              <Space direction="vertical" style={{ width: '100%' }} size={6}>
                {' '}
                <Space style={{ width: '100%', justifyContent: 'space-between' }}>
                  {' '}
                  <Space>
                    {' '}
                    {t.completed ? (
                      <CheckCircleFilled style={{ color: '#52c41a' }} />
                    ) : (
                      <ClockCircleOutlined style={{ color: '#8b949e' }} />
                    )}{' '}
                    <span style={{ fontSize: 14, fontWeight: 600 }}>{t.name}</span>{' '}
                    {t.completed && <Tag color="success">已完成</Tag>}{' '}
                  </Space>{' '}
                  <Tag color="gold">{t.reward}</Tag>{' '}
                </Space>{' '}
                <div style={{ fontSize: 12, color: '#8b949e' }}>{t.description}</div>{' '}
                <div>
                  {' '}
                  <div style={{ fontSize: 11, color: '#8b949e', marginBottom: 4 }}>
                    {' '}
                    进度: {t.progress} / {t.target}{' '}
                  </div>{' '}
                  <Progress
                    percent={percent}
                    showInfo={false}
                    strokeColor={t.completed ? '#52c41a' : '#ff4d4f'}
                    size="small"
                  />{' '}
                </div>{' '}
              </Space>{' '}
            </List.Item>
          );
        }}
      />{' '}
      <div
        style={{
          marginTop: 16,
          padding: 12,
          background: '#1c2128',
          borderRadius: 6,
          fontSize: 11,
          color: '#8b949e',
        }}
      >
        {' '}
        💡 任务每日 0 点（北京时间）刷新。部分任务由 P3 黑哥们模块启用。{' '}
      </div>{' '}
    </div>
  );
}
